import React from 'react'

import { Button } from '@/components/ui/button'

interface Props {
  selectedClientName: string
  onClear: () => void
}

const ClearClientMessage: React.FC<Props> = ({
  selectedClientName,
  onClear,
}) => (
  <p className="mb-2 italic">
    Not {selectedClientName}? Click{' '}
    <Button
      variant="plain"
      className="underline"
      onClick={onClear}
      type="button"
    >
      here
    </Button>{' '}
    to clear the client details.
  </p>
)

export default ClearClientMessage
